import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/images/remote-tablet.png'


const _hoisted_1 = { class: "section-profits" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "section-profits__left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "remote visit"
  })
], -1)
const _hoisted_3 = { class: "section-profits__right" }
const _hoisted_4 = { class: "profits-list" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { href: "#" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBtn = _resolveComponent("UiBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            class: "profits-list__item"
          }, [
            _createElementVNode("img", {
              src: require(`@/assets/icons/${benefit.img}.png`),
              alt: "asset"
            }, null, 8, _hoisted_5),
            _createElementVNode("p", null, _toDisplayString(_ctx.dict.benefits[benefit.name]), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("a", _hoisted_6, [
        _createVNode(_component_UiBtn, {
          type: "register",
          class: "cta-btn",
          "default-icon": true
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.dict.makeAppointment), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}